import { type SupportedLocale } from '@zep-us/i18n';

export type NativeLanguage = {
  locale: SupportedLocale;
  nativeName: string;
};

/**
 * 지원 언어 목록 - 각 언어의 네이티브 이름으로 표시
 * 순서가 보장되며, 드롭다운에서 이 순서대로 표시됨
 */
export const NATIVE_LANGUAGE_LIST: NativeLanguage[] = [
  { locale: 'en', nativeName: 'English' },
  { locale: 'ko', nativeName: '한국어' },
  { locale: 'ja', nativeName: '日本語' },
  { locale: 'zh-CN', nativeName: '中文' },
  { locale: 'zh-TW', nativeName: '繁體中文' },
  { locale: 'zh-HK', nativeName: '繁體中文 (香港)' },
  { locale: 'es', nativeName: 'Español' },
  { locale: 'fr', nativeName: 'Français' },
  { locale: 'de', nativeName: 'Deutsch' },
  { locale: 'it', nativeName: 'Italiano' },
  { locale: 'pt', nativeName: 'Português' },
  { locale: 'ru', nativeName: 'Русский' },
  { locale: 'tr', nativeName: 'Türkçe' },
  { locale: 'nl', nativeName: 'Nederlands' },
  { locale: 'pl', nativeName: 'Polski' },
  { locale: 'id', nativeName: 'Bahasa Indonesia' },
  { locale: 'th', nativeName: 'ภาษาไทย' },
  { locale: 'vi', nativeName: 'Tiếng Việt' },
  { locale: 'fil', nativeName: 'Filipino' },
  { locale: 'ms', nativeName: 'Bahasa Melayu' },
  { locale: 'km', nativeName: 'ខ្មែរ' },
  { locale: 'uz', nativeName: 'Oʻzbek' },
  { locale: 'hi-IN', nativeName: 'हिन्दी' },
  { locale: 'bn-IN', nativeName: 'বাংলা' },
  { locale: 'te-IN', nativeName: 'తెలుగు' },
  { locale: 'pa-IN', nativeName: 'ਪੰਜਾਬੀ' },
  { locale: 'ml-IN', nativeName: 'മലയാളം' },
  { locale: 'ta-IN', nativeName: 'தமிழ்' },
  { locale: 'en-SG', nativeName: 'English (Singapore)' },
  { locale: 'pt-BR', nativeName: 'Português (Brasil)' },
  { locale: 'et', nativeName: 'Eesti' },
  { locale: 'fi', nativeName: 'Suomi' },
];

/**
 * locale을 네이티브 언어명으로 빠르게 변환하기 위한 매핑
 */
export const LOCALE_TO_NATIVE_NAME = NATIVE_LANGUAGE_LIST.reduce(
  (map, lang) => {
    map[lang.locale] = lang.nativeName;
    return map;
  },
  {} as Record<SupportedLocale, string>,
);
